import React from 'react';
import SalvPage from '../../common/SalvPage';
import { useMe } from '../../organisation/useMe';
import { SalvTab, SalvTabList, SalvTabPanel, SalvTabs } from '@salvapp/ui-components';
import General from './tabs/General';
import Screening from './tabs/Screening';
import Monitoring from './tabs/Monitoring';
import Risk from './tabs/Risk';
import { useSearchParams } from 'react-router';
import { isFeatureEnabled, ORGANISATION_FEATURE } from '../../organisation/feature/helper';
import { SearchParamKeys } from '../../common/searchParamKeys';

// TODO images need to be small and cached

const Configuration = () => {
  const { features } = useMe();
  const [searchParams, setSearchParams] = useSearchParams();
  return (
    <SalvPage title={'Configuration'}>
      <SalvTabs
        value={searchParams.get(SearchParamKeys.product) || ConfigurationProduct.GENERAL}
        onChange={(product) => setSearchParams({ product })}
        className={'p-b-64'}
      >
        <SalvTabList>
          <SalvTab value={ConfigurationProduct.GENERAL} title={'General'} />
          {isFeatureEnabled(ORGANISATION_FEATURE.SANCTIONS, features) && (
            <SalvTab value={ConfigurationProduct.SCREENING} title={'Screening'} />
          )}
          {isFeatureEnabled(ORGANISATION_FEATURE.MONITORING, features) && (
            <SalvTab value={ConfigurationProduct.MONITORING} title={'Monitoring'} />
          )}
          {isFeatureEnabled(ORGANISATION_FEATURE.RISK, features) && (
            <SalvTab value={ConfigurationProduct.RISK} title={'Risk'} />
          )}
        </SalvTabList>
        <SalvTabPanel value={ConfigurationProduct.GENERAL}>
          <General />
        </SalvTabPanel>
        {isFeatureEnabled(ORGANISATION_FEATURE.SANCTIONS, features) && (
          <SalvTabPanel value={ConfigurationProduct.SCREENING}>
            <Screening />
          </SalvTabPanel>
        )}
        {isFeatureEnabled(ORGANISATION_FEATURE.MONITORING, features) && (
          <SalvTabPanel value={ConfigurationProduct.MONITORING}>
            <Monitoring />
          </SalvTabPanel>
        )}
        {isFeatureEnabled(ORGANISATION_FEATURE.RISK, features) && (
          <SalvTabPanel value={ConfigurationProduct.RISK}>
            <Risk />
          </SalvTabPanel>
        )}
      </SalvTabs>
    </SalvPage>
  );
};

export default Configuration;

export const ConfigurationProduct = {
  GENERAL: 'general',
  SCREENING: 'screening',
  MONITORING: 'monitoring',
  RISK: 'risk',
} as const;
